import(/* webpackMode: "eager" */ "/home/harmo/projects/Synetudes/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/harmo/projects/Synetudes/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/harmo/projects/Synetudes/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorHandler"] */ "/home/harmo/projects/Synetudes/src/components/errors/error-handler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/home/harmo/projects/Synetudes/src/components/helpers/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DndContextProvider"] */ "/home/harmo/projects/Synetudes/src/components/layout/dnd-context-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/home/harmo/projects/Synetudes/src/components/layout/query-client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContextMenu","ContextMenuTrigger"] */ "/home/harmo/projects/Synetudes/src/components/overlay/context-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Root"] */ "/home/harmo/projects/Synetudes/src/components/primitives/root.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FontContextProvider"] */ "/home/harmo/projects/Synetudes/src/hooks/useFontContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyboardContextProvider"] */ "/home/harmo/projects/Synetudes/src/hooks/useKeyboardContext.tsx");
